
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rankings",
      function () {
        return require("private-next-pages/rankings/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rankings"])
      });
    }
  